export default "__VITE_ASSET__e423baff__"